import { Component, Input, OnInit, OnDestroy, OnChanges } from '@angular/core';
import { MediaChange, ObservableMedia } from '@angular/flex-layout';

import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';

import { getHours } from 'date-fns';

import { RoleTextPipe } from '../../pipes/roletext.pipe';

import { ConfigService } from '../../services/config/config.service';
import { SplashService } from '../../services/splash/splash.service';
import { UserService, UserInfo } from '../../services/user/user.service';

@Component({
    selector: 'app-user-info',
    styleUrls: ['userinfo.component.css'],
    templateUrl: 'userinfo.component.html',
})
export class UserInfoComponent implements OnChanges, OnDestroy, OnInit {
    private _subrelease: Subject<void> = new Subject<void>();
    private _timerHandle: number;

    greeting: string;
    username: string;
    role: string;
    SmallDisplay: boolean;
    @Input() user: UserInfo;
    @Input() showName: boolean;

    constructor(
        private configService: ConfigService,
        private mediaChange: ObservableMedia,
        private splashService: SplashService,
        private userService: UserService,
        private rolePipe: RoleTextPipe
    ) {}

    ngOnChanges() {
        this.username = (this.user.FirstName || '') + ' ' + (this.user.LastName || '');
        this.role = this.rolePipe.transform(this.user.CurrentRole);
    }

    ngOnDestroy() {
        if (this._timerHandle) {
            window.clearTimeout(this._timerHandle);
        }
        this._timerHandle = null;

        this._subrelease.next();
        this._subrelease.complete();
    }

    ngOnInit() {
        const self = this;

        // Set the time of day greeting
        self.SetTimeGreeting();

        self.username = (self.user.FirstName || '') + ' ' + (self.user.LastName || '');

        self.SmallDisplay = self.mediaChange.isActive('xs') || self.mediaChange.isActive('sm');

        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subrelease))
            .subscribe(media => {
                self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
            });
    }

    SetTimeGreeting() {
        const now = new Date();
        const hour = getHours(now);

        if ((hour >= 0 && hour <= 4) || hour >= 18) {
            this.greeting = 'Good evening';
        } else if (hour > 4 && hour < 12) {
            this.greeting = 'Good morning';
        } else if (hour >= 12 && hour < 18) {
            this.greeting = 'Good afternoon';
        }

        // Set up a one hour timer from now to check this again.
        this._timerHandle = window.setTimeout(() => {
            this.SetTimeGreeting();
        }, 60 * 60 * 1000);
    }

    SwitchRole(newRole: string) {
        if (!newRole) {
            return;
        }

        switch (newRole) {
            case 'Developer':
                this.userService.SetUserCurrentRole('Developer');
                return;
            case 'SystemAdmin':
                this.userService.SetUserCurrentRole('SystemAdmin');
                return;
            case 'DistrictAdmin':
                this.userService.SetUserCurrentRole('DistrictAdmin');
                return;
            case 'DistrictUser':
                this.userService.SetUserCurrentRole('DistrictUser');
                return;
            case 'CollegeAdmin':
                this.userService.SetUserCurrentRole('CollegeAdmin');
                return;
            case 'Advisor':
                this.userService.SetUserCurrentRole('Advisor');
                return;
            case 'CollegeSupport':
                this.userService.SetUserCurrentRole('CollegeSupport');
                return;
            case 'SchoolAdmin':
                this.userService.SetUserCurrentRole('SchoolAdmin');
                return;
            case 'Counselor':
                this.userService.SetUserCurrentRole('Counselor');
                return;
            case 'Student':
                this.userService.SetUserCurrentRole('Student');
                return;
            case 'Parent':
                this.userService.SetUserCurrentRole('Parent');
                return;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/userinfo/userinfo.component.ts